import { setWorkerUrl } from "maplibre-gl";
import workerSource from "../../../../.maplibre/worker-source";

// maplibre-gl 6 looks for its worker next to its own module file, which the app
// bundle does not have. npm postinstall (scripts/bundle-maplibre-worker.cjs)
// bundles the worker into one module, and the app starts it from a Blob URL.
// The import makes a build without that file fail, instead of shipping a map
// that loads no vector data. It also needs no served file, so no MIME type,
// base href or service-worker cache rule can break it.
setWorkerUrl(URL.createObjectURL(new Blob([workerSource], { type: "text/javascript" })));
